import React from "react";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import { Icon, IconGlyph } from "../../lib/Icon";

export type ZoomControlProps = {
  zoomLevel?: number;
  incrementZoom?: (event: React.MouseEvent) => void;
  decrementZoom?: (event: React.MouseEvent) => void;
  canZoomIn?: boolean;
  canZoomOut?: boolean;
};

export const ZoomControl = ({
  zoomLevel,
  incrementZoom,
  decrementZoom,
  canZoomIn,
  canZoomOut,
}: ZoomControlProps): JSX.Element => {
  const { t } = useCustomTranslation("Header");

  return (
    <div className="zoom-control">
      {incrementZoom && decrementZoom && zoomLevel && (
        <>
          <span className="zoom-control__line" />
          <div className="zoom-control__label">{t("Zoom")}</div>
          <button
            className="zoom-control__button web-gallery-zoom-out-pendo-tracking"
            onClick={decrementZoom}
            disabled={!canZoomOut}
            aria-label="Zoom Out"
          >
            <Icon
              glyph={IconGlyph.MINUS_ROUND}
              className="zoom-control__icon"
            />
          </button>
          <button
            className="zoom-control__button web-gallery-zoom-in-pendo-tracking"
            onClick={incrementZoom}
            disabled={!canZoomIn}
            aria-label="Zoom In"
          >
            <Icon glyph={IconGlyph.PLUS_ROUND} className="zoom-control__icon" />
          </button>
        </>
      )}
    </div>
  );
};
